import styled from '@emotion/styled';

import { openComponentModal } from '../../../../PageBuilder/helpers/modal';
import { EmailContractorModal } from '../../../../Utilities';

// Avoid title collision with modal close button (X)
const Title = styled.span`
  display: inline-block;
  width: 90%;
`;

export const openEmailContractorModal = (contractor, options = {}) => {
  if (!contractor) {
    return;
  }

  const { isBuilder } = options;

  openComponentModal(
    () => <EmailContractorModal schemaOnly contractor={contractor} source="insulation" isBuilder={isBuilder} />,
    <Title>Email to {contractor.name}</Title>
  );
};
